module.exports = __webpack_public_path__ + "img/logo-esic-topo.53bde5a6.png";